/**
 * Utility function to set the hidden property of multiple elements.
 * @param {HTMLElement[]} elements - Array of HTML elements to modify.
 * @param {boolean} hidden - If true, sets the elements to hidden; if false, shows them.
 */
const setElementsHidden = (elements, hidden) => {
  elements.forEach((element) => {
    element.hidden = hidden;
  });
}

/**
 * Sets the visibility of the main header and saved search button.
 * @param {boolean} hidden - If true, hides the elements; if false, shows them.
 */
const setHeaderAndSaveButtonVisibility = (hidden, header, savedSearchContainer) => {
  setElementsHidden([header, savedSearchContainer], hidden);
};

export default setHeaderAndSaveButtonVisibility;